import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import {
    Grid,
    GridColumn,
    GridDetailRow,
    GridToolbar,
} from "@progress/kendo-react-grid";
import { Popup } from "@progress/kendo-react-popup";
import { formatNumber } from "@telerik/kendo-intl";
import * as moment from "moment";
import * as React from "react";
import { toastr } from "react-redux-toastr";
import { NavLink } from "react-router-dom";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import "../../Styles/RiskViews.scss";
import ActionAlertStackHolderComponent from "./Component/ActionAlertStackHolderComponent";
import ActionProgressPopup from "./Component/ActionProgressPopup";
import ActualCompDate from "./Component/ActualCompDate";
import CostComponent from "./Component/CostComponent";
import MitigationApprovedCell from "./Component/MitigationApprovedCell";
import MitigationCurrencyFormat from "./Component/MitigationCurrencyFormat";
import MitigationNameCell from "./Component/MitigationNameCell";
import MitigationStatus from "./Component/MitigationStatus";
import OriginalCompDate from "./Component/OriginalCompDate";
import OwnerComponent from "./Component/OwnerComponent";
import PercentageCompletion from "./Component/PercentageCompletion";
import ProjCompDate from "./Component/ProjCompDate";
import ProximityDate from "./Component/ProximityDate";
import ReductionProbability from "./Component/ReductionProbability";
import SPICell from "./Component/SPICell";
import MitigationColoumns from "./MitigationColoumns.json";
import ActionPersistence from "./ActionPersistence.json";
import ActionType from "./Component/ActionType";
import ActionQualitativeImpact from "./Component/ActionQualitativeImpact";
import ActionRegisterFormView from "./Component/ActionRegisterFormView";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import ActionTitle from "./Component/ActionTitle";

export class MitigationExpandEdit extends GridDetailRow {
  
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      editID: null,
      enterEditFlag: false,
      openDeleteModelFlagView: false,
      currentChangedValue: {},
      btnHideFlag: true,
      addActionbtnHideFlag: true,
      loader: false,
      persistenceActionGrid: ActionPersistence,
      persistenceActionGridTemp:ActionPersistence,
      formEditFlag: false,
      showFormView: false,
      formData: {},
      actionCompletionDatePopup:false,
      updatedfield:0
    };
    this.gridRef = React.createRef();
  }

  openActionCompletionDatePopup=()=>{
    this.setState({ actionCompletionDatePopup: true });
  }
  closeActionCompletionDatePopup=()=>{
    this.setState({ actionCompletionDatePopup: false });
    this.props.refreshRisk();
  }
  componentDidMount = () => {
    this.init();
  };

  init = async () => {
    const data = this.props.dataItem.mitigationResps
      ? this.props.dataItem.mitigationResps
      : {};
    const isOpportunity = this.props.dataItem.isOpportunity
      ? this.props.dataItem.isOpportunity
      : "Threat";
    const persis = this.props.persistenceActionGrid
      ? this.props.persistenceActionGrid
      : ActionPersistence;
    await this.createDynamicColsInMitigation(data, isOpportunity, persis);
    if (this.gridRef?.current) {
      const gridColumns = this.gridRef.current.columns;
       gridColumns.map((item,i) => {
        item["orderIndex"] = i;
        return item;
      });
      this.setState({ persistenceActionGridTemp: gridColumns });
    } 
  };

  createDynamicColsInMitigation = async (
    products,
    isOpportunity,
    persistence
  ) => {
    try {
      let impactColumn = [];
      let impactMaster = [];
      if (products && products.length > 0) {
        impactMaster = products[0].impactResponse;
      }
      products.map((res, i) => {
        res["role"] = this.props.dataItem.role;

        if (res.impactResponse) {
          res.impactResponse.map((item, j) => {
            if (impactColumn.length > 0) {
              if (!impactColumn.includes(item.name)) {
                impactColumn.push(item.name);
              }
            } else {
              impactColumn.push(item.name);
            }
          });
        }
      });
      
       if (impactColumn.length > 0) {
        products.map((res) => {
          impactColumn.map((col) => {
            let temp =
              res.impactResponse &&
              res.impactResponse.find((item) => item.name === col);
            if (temp) {
              res[col] =
                temp.impactType == "Quantitative" ? temp.value : temp.qValue;
            } else {
              res[col] = undefined;
            }
          });
        });
      }
      let columnsToShow = [];
      if (impactColumn.length > 0) {
        columnsToShow = impactColumn.map((item, index) => (
          <GridColumn
            title={this.getImpactUnit(item, impactMaster)}
            children={[
              {
                headerCell: (props) =>
                  this.CustomHeaderCell(props, impactMaster),
                field: item,
                width: this.getFieldWidth(item, persistence),
                cell: (props) =>
                  this.getImpactTypeComponent(
                    item,
                    props,
                    isOpportunity,
                    impactMaster
                  ),
              },
            ]}
          />
        ));
      }
      if (!this.state.impactMitigationColumns) {
        products.map((riskReg) => {
          if (riskReg.actualCompletionDate) {
            riskReg.actualCompletionDate = new Date(
              riskReg.actualCompletionDate
            );
          }
          if (riskReg.originalCompletionDate) {
            riskReg.originalCompletionDate = new Date(
              riskReg.originalCompletionDate
            );
          }
          if (riskReg.projectedCompletionDate) {
            riskReg.projectedCompletionDate = new Date(
              riskReg.projectedCompletionDate
            );
          }
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
          if (riskReg.updatedDate) {
            riskReg.updatedDate = new Date(riskReg.updatedDate);
          }
          if (riskReg.createdDate) {
            riskReg.createdDate = new Date(riskReg.createdDate);
          }
          if (riskReg.closedDate) {
            riskReg.closedDate = new Date(riskReg.closedDate);
          }
          //Export issue in Action
          // if(riskReg.isOpen===true||riskReg.isOpen==="Open"){
          //   riskReg.isOpen=true;
          // }else{
          //   riskReg.isOpen=false;
          // }
          // if(riskReg.approved===true||riskReg.approved==="Yes"){
          //   riskReg.approved=true;
          // }else{
          //   riskReg.approved=false;
          // }
        });

        this.setState({
          ...this.state,
          impactMitigationColumns: columnsToShow,
          data: products,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  getImpactTypeComponent = (name, props, isOpportunity, impactMaster) => {
    var impactTemp = impactMaster.find((item) => item.name == name);
    if (impactTemp && impactTemp.impactType == "Quantitative") {
      return (
        <MitigationCurrencyFormat
          {...props}
          onEditCell={this.enterEdit}
          isOpportunity={isOpportunity}
          riskDetails={this.props.dataItem}
        />
      );
    } else {
      return (
        <ActionQualitativeImpact
          {...props}
          onEditCell={this.enterEdit}
          riskDetails={this.props.dataItem}
          heatMapCount={this.props.heatMapCount}
        />
      );
    }
  };

  getFieldWidth = (cellFieldName, persistence) => {
    let width = "100px";
    let res =
      persistence && persistence.find((item) => item.field === cellFieldName);
    if (res) {
      width = res.width;
    }
    return width;
  };
  getImpactUnit = (impact, impactMaster) => {
    var impactTemp = impactMaster.find((item) => item.name == impact);
    var res = impact;
    if (
      impactTemp &&
      impactTemp.name &&
      impactTemp.impactType == "Quantitative"
    ) {
      res = impactTemp.name + " / " + impactTemp.units;
    }
    if (this.props.dataItem.isOpportunity === "Opportunity") {
      return "Increase in " + res;
    } else {
      return "Reduction in " + res;
    }
  };
  cellWithBackGround = (props) => {
    const origcompbreach = props.dataItem.originalCompletionDate > new Date();
    const style = {
      backgroundColor: origcompbreach
        ? "rgb(243, 23, 0, 0.32)"
        : "rgb(55, 180, 0,0.32)",
    };
  };

  getOriginalValueFromRisk = (impact) => {
    var res = "0/0";
    var impactPost =
      this.props.dataItem.impactResponse &&
      this.props.dataItem.impactResponse.find(
        (item) => item.name == impact && item.type == "Post"
      );
    var preImpact =
      this.props.dataItem.impactResponse &&
      this.props.dataItem.impactResponse.find(
        (item) => item.name == impact && item.type == "Pre"
      );
    var currentImpact =
      this.props.dataItem.impactResponse &&
      this.props.dataItem.impactResponse.find(
        (item) => item.name == impact && item.type == "Current"
      );

    if (preImpact && preImpact.impactType == "Quantitative") {
      var pre = preImpact.value ? preImpact.value.toString() : 0;
      var post = preImpact.postImpactValue
        ? preImpact.postImpactValue.toString()
        : 0;
      var current = currentImpact ? currentImpact.currentImpactValue.toString() : 0;
      var preVal = formatNumber(parseFloat(pre), "##,#");
      var postVal = formatNumber(parseFloat(post), "##,#");
      var curentVal = formatNumber(parseFloat(current), "##,#");
      res = preVal + "/" + postVal + "/" + curentVal;
    } else {
      var pre = preImpact ? preImpact.qValue.toString() : 0;
      var post = impactPost ? impactPost.postQvalue.toString() : 0;
      var current = currentImpact ? currentImpact.currentQvalue.toString() : 0;
      var preVal = formatNumber(parseFloat(pre), "##,#");
      var postVal = formatNumber(parseFloat(post), "##,#");
      var curentVal = formatNumber(parseFloat(current), "##,#");

      res = preVal + "/" + postVal + "/" + curentVal;
    }

    return res;
  };
  itemChange = (event) => {
    const changedValue = { ...event.dataItem, [event.field]: event.value };
    const dataValue = this.state.data.map((item) =>
      item.riskRegisterActionId === event.dataItem.riskRegisterActionId
        ? { ...item, [event.field]: event.value }
        : item
    );
    this.setState({
      ...this.state,
      currentChangedValue: changedValue,
      data: dataValue,
    });
    //dirty check
    let dirtData = this.state.data.find(
      (item) => changedValue.riskRegisterActionId == item.riskRegisterActionId
    );
    if (
      dirtData &&
      changedValue[this.state.editField] == dirtData[this.state.editField]
    ) {
      this.exitEdit();
      return;
    } else {
      this.closeEditandSaveMitigation(changedValue);
    }
  };
  handleActulaCompletionDate=(date)=>{
    let temp=this.state.currentChangedValue;
    temp["actualCompletionDate"]=date;
    this.setState({
      ...this.state,
      currentChangedValue: temp,
    })
  }
  closeEditandSaveMitigation = async (data) => {
    try {
      this.setState({ editID: null, enterEditFlag: false });
      if (!data.riskRegisterId) {
        return;
      }
      var mitigationReq = {};
      var imapctList = [];
      var QualityImpact = [];
      for (let field in data) {
        if (MitigationColoumns.hasOwnProperty(field)) {
          mitigationReq[field] = data[field];
        } else {
          var impactReq = {};
          var qualReq = {};
          var impact =
            data.impactResponse &&
            data.impactResponse.find((item) => item.name == field);
          if (impact && impact.impactType == "Quantitative") {
            impactReq["ImpactId"] = impact.impactId;
            impactReq["ProjectRiskActionId"] = data.riskRegisterActionId;
            var val = data[field];
            impactReq["Value"] = parseFloat(val);
            // await this.impactUpdate(impactReq);
            imapctList.push(impactReq);
          } else if (impact) {
            qualReq["ProjectRiskActionId"] = data.riskRegisterActionId;
            qualReq["QualitativeImpactId"] = impact.qualitativeImpactId;
            qualReq["QValue"] = data[field];
            QualityImpact.push(qualReq);
          }
        }
      }
      mitigationReq["impactResponse"] = imapctList;
      mitigationReq["QualityImpact"] = QualityImpact;
      console.log("mitigationReq", mitigationReq);
      await this.mitigationUpdate(mitigationReq);
    } catch (error) {
      console.error(error);
      this.setState({ loader: false });
    }
  };

  impactUpdate = async (req) => {
    try {
      let response = await Api.addImpactByMitigation(req);
    } catch (error) {
      console.error(error);
    }
  };
  processInput=(input) =>{
    if (typeof input === "string") {
      return input.split(",").map((item) => item.trim()); // Optional: trim spaces around items
    } else if (Array.isArray(input)) {
      return input;
    } else {
      return [];
    }
  }
  mitigationUpdate = async (req) => {
    try {
      if (!req.name || req.name.trim() === "") {
        toastr.error("The name field should not be empty.");
        return;
      }
      this.setState({ loader: true });
      if (req.actionType) {
        req.actionType =req.actionType==" [blank]"?null:req.actionType;
      }
      req.name = req.name ? req.name.slice(0, 30) : "";
      req.cost = parseFloat(req.cost);
      req.reductionFrequency = parseFloat(req.reductionFrequency);
      req.revisedProductionLoss = parseFloat(req.revisedProductionLoss);
      req.revisedProjectCostIncrease = parseFloat(
        req.revisedProjectCostIncrease
      );
      req.revisedProjectDurationIncrease = parseFloat(
        req.revisedProjectDurationIncrease
      );
      req.riskRegisterActionId = parseFloat(req.riskRegisterActionId);
      req.riskRegisterId = parseFloat(req.riskRegisterId);
      req.sharePriceReduction = parseFloat(req.sharePriceReduction);
      req.spi = parseFloat(req.spi);
      if (
        req.inEdit == "percentageCompletion" &&
        req.percentageCompletion == 100 &&!req.actualCompletionDate
      ) {
         req.isOpen = false;
      }
      if (
        req.inEdit == "percentageCompletion" &&
        req.percentageCompletion == 100 &&
        !req.actualCompletionDate
      ) {
        this.setState({ loader: false });
        this.openActionCompletionDatePopup();
        return;
      }

      if (req.inEdit != "status") {
        req.status = null;
      }
      req.isOpen=req.isOpen=="Open"||req.isOpen==true?true:false;
      req.approved=req.approved==="Yes"||req.approved===true?true:false;
      if (req.inEdit == "isOpen") {
        if (!req.isOpen && !req.actualCompletionDate) {
          this.setState({ loader: false });
          this.openActionCompletionDatePopup();
          return;
        } else {
          req.percentageCompletion =
            req.percentageCompletion == 100 ? 0 : req.percentageCompletion;
        }
      }
      req.percentageCompletion = req.percentageCompletion
        ? req.percentageCompletion
        : 0;
   
      if (req.inEdit == "actualCompletionDate" && req.actualCompletionDate) {
        req.isOpen = false;
        
      }
      if (req.inEdit == "originalCompletionDate") {
        req.projectedCompletionDate = req.originalCompletionDate;
      }
      //new
      if(req.percentageCompletion===100){
        req.isOpen=false;
      }
      if(req.isOpen==true){
        req.actualCompletionDate=null;
      }

      // if(req.isOpen==false){
      //   req.percentageCompletion=100;
      // }
      //end
      //Auto Fill Completion Date change
      if (!req.originalCompletionDate && req.projectedCompletionDate) {
        req.originalCompletionDate = req.projectedCompletionDate;
      }
      if (!req.projectedCompletionDate && req.actualCompletionDate) {
        req.projectedCompletionDate = req.actualCompletionDate;
        if (!req.originalCompletionDate) {
          req.originalCompletionDate = req.actualCompletionDate;
        }
      }
      req.originalCompletionDate = req.originalCompletionDate
        ? moment(req.originalCompletionDate).format("YYYY-MM-DD")
        : null;
      req.projectedCompletionDate = req.projectedCompletionDate
        ? moment(req.projectedCompletionDate).format("YYYY-MM-DD")
        : null;
      req.actualCompletionDate = req.actualCompletionDate
        ? moment(req.actualCompletionDate).format("YYYY-MM-DD")
        : null;
      req.proximityDate = req.proximityDate
        ? moment(req.proximityDate).format("YYYY-MM-DD")
        : null;
      req.delayConsequence = req.delayConsequence
        ? req.delayConsequence.toString()
        : null;
        if (req.owner&&typeof req.owner !== "string") {
          req["userId"] =req.owner.text===" [blank]"?null: req.owner.value;
          req.owner =req.owner.text===" [blank]"?null: req.owner.text;
        }
        req.actionAlertStakeHolders=this.processInput(req.actionAlertStakeHolders);
      req.createdDate = new Date();
      req.createdBy = parseInt(secureLocalStorage.getItem("loginUserId"));
      delete req["inEdit"];
      let response = await Api.createRegisterMitigation(req);
      if (response.status === 200) {
        this.setState({ loader: false, updatedfield:req.riskRegisterActionId });
        // this.props.refreshRisk();
        this.closeActionCompletionDatePopup()
      } else {
        toastr.error(response.message);
        this.setState({ loader: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ loader: false });
    }
  };

  addRecord = () => {
    // const { data } = this.state;
    // const newRecord = {};
    // this.setState({
    //   data: [newRecord, ...data],
    //   editID: newRecord.riskRegisterActionId,
    //   addActionbtnHideFlag: false,
    // });
    this.setState({ ...this.state, showFormView: true });
  };
  discard = (dataItem) => {
    const data = [...this.state.data];
    data.splice(0, 1);
    this.setState({ data });
    this.setState({ addActionbtnHideFlag: true });
  };

  cellRender = (tdElement, cellProps) => {
    const dataItem = cellProps.dataItem;
    const cellField = cellProps.field;
    const inEditField = dataItem["inEdit"];

    const additionalProps =
      cellField && cellField === inEditField
        ? {
            ref: (td) => {
              const input = td && td.querySelector("input");
              const activeElement = document.activeElement;

              if (
                !input ||
                !activeElement ||
                input === activeElement ||
                !activeElement.contains(input)
              ) {
                return;
              }

              if (input.type === "checkbox") {
                input.focus();
              } else {
                input.select();
              }
            },
          }
        : {
            onClick: () => {
              this.enterEdit(dataItem, cellField);
            },
            onFocus: () => {
              this.enterEdit(dataItem, cellField);
            },
            tabIndex: "0",
          };
    if (tdElement && tdElement.props) {
      return React.cloneElement(
        tdElement,
        { ...tdElement.props, ...additionalProps },
        tdElement.props.children
      );
    } else {
      return <td></td>;
    }
  };

  rowRender = (trElement,props) => {
    const riskRegisterActionId =this.state.updatedfield;

    const bgcolor={
      backgroundColor:"rgba(0, 255, 76, 0.308)",
    }
    const trProps = {
      ...trElement.props,
      style: riskRegisterActionId==props.dataItem.riskRegisterActionId  ? bgcolor:null,
      onMouseDown: (event) => {
        event.preventExit = true;
        clearTimeout(event.preventExitTimeout);
        event.preventExitTimeout = setTimeout(() => {
          event.preventExit = undefined;
        });
      },
      onBlur: (event) => {
        if (
          this.state.editField == "actionAlertStakeHolders" ||
          this.state.editField == "status"
        ) {
          return;
        }
        clearTimeout(event.blurTimeout);
        if (!event.preventExit) {
          event.blurTimeout = setTimeout(() => {
            this.exitEdit();
          });
        }
      },
      onFocus: (event) => {
        clearTimeout(event.blurTimeout);
      },
    };
    return React.cloneElement(
      trElement,
      { ...trProps },
      trElement.props.children
    );
  };

  enterEdit = (dataItem, field) => {
    const dataValue = this.state.data.map((item) => ({
      ...item,
      inEdit:
        item.riskRegisterActionId === dataItem.riskRegisterActionId
          ? field
          : undefined,
    }));
    this.setState({
      data: dataValue,
      currentChangedValue: dataItem,
      editField: field,
    });
  };

  exitEdit = () => {
    const dataValue = this.state.data.map((item) => ({
      ...item,
      inEdit: undefined,
    }));
    this.setState({
      data: dataValue,
    });
  };

  getImpactId = (impact) => {
    var res = 0;
    var impactTemp =
      this.props.dataItem.impactResponse &&
      this.props.dataItem.impactResponse.find((item) => item.name == impact);
    if (impactTemp && impactTemp.impactId) {
      res = impactTemp.impactId;
    }

    return res;
  };
  saveNewRecord = async (req) => {
    try {
      if (!req.name || req.name.trim() === "") {
        toastr.error("The name field should not be empty.");
        return;
      }

      //Projected Completion Date and Original logic should go in here
      this.setState({ ...this.state, loader: true, btnHideFlag: false });
      delete req["inEdit"];
      delete req["riskRegisterActionId"];
      req["RiskRegisterId"] = this.props.dataItem.riskRegisterId;
      req.createdBy = parseInt(secureLocalStorage.getItem("loginUserId"));

      var impactList = [];

      for (let field in req) {
        var impact = {};
        if (MitigationColoumns.hasOwnProperty(field)) {
          req[field] = req[field];
        } else {
          if (field != "RiskRegisterId") {
            impact["name"] = field;
            impact["value"] = req[field];
            impact["impactId"] = await this.getImpactId(field);
            impactList.push(impact);
          }
        }
      }
      req.name = req.name ? req.name.slice(0, 30) : "";
      req["impactResponse"] = impactList;
      req.createdDate = new Date();

      if (req.percentageCompletion == 100) {
        req.isOpen = false;
        req.actualCompletionDate =
          req.actualCompletionDate == undefined
            ? moment(new Date()).format("YYYY-MM-DD")
            : moment(req.actualCompletionDate).format("YYYY-MM-DD");
      }
      req.percentageCompletion = req.percentageCompletion
        ? req.percentageCompletion
        : 0;

      if (req.actualCompletionDate != undefined && req.actualCompletionDate) {
        req.isOpen = false;
      }

      if (
        req.isOpen != undefined &&
        req.isOpen == false &&
        req.actualCompletionDate == undefined
      ) {
        req.actualCompletionDate = moment(new Date()).format("YYYY-MM-DD");
      }

      if (req.actionType) {
        req.actionType = req.actionType; //req.actionType=="[blank]"?null:req.actionType;
      }
      // req.actualCompletionDate=req.actualCompletionDate?new Date(req.actualCompletionDate.setDate(req.actualCompletionDate.getDate() + 1)):null;
      // req.originalCompletionDate=req.originalCompletionDate?new Date(req.originalCompletionDate.setDate(req.originalCompletionDate.getDate() + 1)):null;
      // req.projectedCompletionDate=req.projectedCompletionDate?new Date(req.projectedCompletionDate.setDate(req.projectedCompletionDate.getDate() + 1)):null;
      req.actualCompletionDate = req.actualCompletionDate
        ? moment(req.actualCompletionDate).format("YYYY-MM-DD")
        : null;
      req.originalCompletionDate = req.originalCompletionDate
        ? moment(req.originalCompletionDate).format("YYYY-MM-DD")
        : null;
      req.projectedCompletionDate = req.projectedCompletionDate
        ? moment(req.projectedCompletionDate).format("YYYY-MM-DD")
        : null;

      //Auto Fill Completion Date for Add change starts
      if (!req.originalCompletionDate && req.projectedCompletionDate) {
        req.originalCompletionDate = req.projectedCompletionDate;
      }
      if (!req.projectedCompletionDate && req.actualCompletionDate) {
        req.projectedCompletionDate = req.actualCompletionDate;
        if (!req.originalCompletionDate) {
          req.originalCompletionDate = req.actualCompletionDate;
        }
      }
      //Auto Fill Completion Date change ends
      //Projected Completion Date should be autopopulated when actual completion date is filled
      req.proximityDate = req.proximityDate
        ? moment(req.proximityDate).format("YYYY-MM-DD")
        : null;
      req.delayConsequence = req.delayConsequence
        ? req.delayConsequence.toString()
        : null;

        if (req.owner&&typeof req.owner !== "string") {
          req["userId"] =req.owner.text===" [blank]"?null: req.owner.value;
          req.owner =req.owner.text===" [blank]"?null: req.owner.text;
        }

      let response = await Api.createRegisterMitigation(req);
      if (response.status === 200) {
        // toastr.success(response.message);
        this.setState({ ...this.state, btnHideFlag: true });

        this.props.refreshRisk();
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false, btnHideFlag: true });
      }
    } catch (error) {
      console.error(error);
    }
  };
  actionButtonsForViewOnly = (event) => {
    let eventData = event.dataItem;
    return (
      <td className=" editBtns">
        <ul className="actionIcon">
          <li>
            <a
              title="View"
              className="greenbtn"
              onClick={() => this.editFormView(eventData)}
            >
              <img src={Images.VIEW} width="12" alt="More" />
            </a>
          </li>
        </ul>
      </td>
    );
  };
  actionButtons = (event) => {
    let eventData = event.dataItem;
    return (
      <td className=" editBtns">
        {eventData.number ? (
          <ul className="actionIcon">
                  <li>
              <a
                title="View"
                className="greenbtn"
                onClick={() => this.editFormView(eventData)}
              >
                <img src={Images.VIEW} width="12" alt="More" />
              </a>
            </li>
            <li>
              <a
                title="Documents"
                className={
                  eventData.documentCount == 0
                    ? "greenbtn roundedBtn icon"
                    : "bluebtn roundedBtn icon"
                }
              >
                <NavLink
                  title="Document"
                  className={
                    eventData.documentCount == 0
                      ? "greenbtn icon"
                      : "bluebtn icon"
                  }
                  to={`/${secureLocalStorage.getItem(
                    "loggedClient"
                  )}/${secureLocalStorage.getItem(
                    "tenantKey"
                  )}/home/documents/riskmitigationdocs/${
                    eventData.riskRegisterActionId
                  }`}
                >
                  <img
                    src={
                      eventData.documentCount == 0
                        ? Images.DOCUMENT
                        : Images.DOCUMENTBLUE
                    }
                    width="12"
                    alt="Document"
                  />
                </NavLink>
              </a>
            </li>
      
            <li>
              <a
                title="Remove"
                onClick={() => this.openDeletePopup(eventData)}
                className="redbtn  icon"
              >
                <img src={Images.TRASH} width="10" alt="edit" />
              </a>
            </li>
          </ul>
        ) : (
          this.state.btnHideFlag && (
            <ul className="actionIcon">
              <li onClick={() => this.saveNewRecord(eventData)}>
                <a title="Save Action" className="greenbtn icon">
                  <img src={Images.CHECKGREEN} width="10" alt="save" />
                </a>
              </li>
              <li>
                <a
                  title="Discard"
                  onClick={() => this.discard(eventData)}
                  className="redbtn  icon"
                >
                  <img src={Images.CLOSE} width="10" alt="edit" />
                </a>
              </li>
            </ul>
          )
        )}
      </td>
    );
  };
  openDeletePopup = (data) => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: true,
      mitigationId: data.riskRegisterActionId,
    });
  };
  closeDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: false,
    });
  };

  deleteMitigation = async () => {
    try {
      var requestParams = {
        DeletedBy: this.state.mitigationId,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.deleteMitigation(requestParams);
      if (response.status === 200) {
        toastr.success(response.message);
        this.props.refreshRisk();
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
    }
  };

  onColumnReorder = (event) => {
    try {
      // this.setState({ ...this.state, persistenceActionGrid: event.target.columnResize.columns });
      // const newArray=this.mergeAndUpdateArrays (this.state.persistenceActionGridTemp,event.target.columnResize.columns);
      // console.log("newArray",newArray);
      let req = {
        ActionDetails: JSON.stringify(event.target.columnResize.columns),
        WorkstreamId: this.props.dataItem.organizationUnitId,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
      };
      Api.persistAction(req);
      this.props.refreshPersistence(event.target.columnResize.columns);
    } catch (err) {
      console.log(err);
    }
  };
  onColumnReorderHomePage = (event) => {
   
      try {
        let req = {
          persistenceDetails: JSON.stringify(event.target.columnResize.columns),
          workstreamId: null,
          UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedDate: new Date(),
          updatedDate: new Date(),
          "screenName": "ACTION-EXPAND-HOME",
        };
        Api.addTaskPersistence(req);
        this.props.refreshPersistence(event.target.columnResize.columns);
      } catch (err) {
        console.log(err);
      }
    
  };
   mergeAndUpdateArrays = (array1, array2) => {
    // Create a Set of indexes present in array2
    const array2Values = new Set(array2.map((item) => item.field));

    // Loop through array1 and push missing items into array2
    array1.forEach((item) => {
      if (!array2Values.has(item.field)) {
        array2.push(item);
      }
    });

    // Sort array2 by index
    array2.sort((a, b) => a.orderIndex - b.orderIndex);
    return array2;
  };
  onColumnResize = (event) => {
    if (event.end) {
      // this.setState({ ...this.state, persistenceActionGrid: event.target.columnResize.columns });
      // const newArray=this.mergeAndUpdateArrays (this.state.persistenceActionGridTemp,event.target.columnResize.columns);
      try {
        let req = {
          ActionDetails: JSON.stringify(event.target.columnResize.columns),
          WorkstreamId: this.props.dataItem.organizationUnitId,
          UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedDate: new Date(),
          updatedDate: new Date(),
        };
        Api.persistAction(req);
        this.props.refreshPersistence(event.target.columnResize.columns);
      } catch (err) {
        console.log(err);
      }
    }
  };
  onColumnResizeHomePage = (event) => {
   if (event.end) {
      try {
        let req = {
          persistenceDetails: JSON.stringify(event.target.columnResize.columns),
          workstreamId: null,
          UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedDate: new Date(),
          updatedDate: new Date(),
          "screenName": "ACTION-EXPAND-HOME",
        };
        Api.addTaskPersistence(req);
        this.props.refreshPersistence(event.target.columnResize.columns);
      } catch (err) {
        console.log(err);
      }
    }
  };
  getReductionTitle = (temp) => {
    try {
      if (this.props.dataItem.isOpportunity === "Opportunity") {
        return "Increase in Probability (%)";
      } else {
        return "Reduction in Probability  (%)";
      }
    } catch (err) {
      return "Probability";
    }
  };
  getGridColum = (columns, editRoleFlag) => {
    let cellFieldName = columns.field;
    let width = columns.width;
    let isHidden=this.isHiddenRiskColumn(cellFieldName);

    if (!cellFieldName) {
      return;
    } 
    else if (cellFieldName == "approved"&& !isHidden) {
      return (
        <GridColumn
          field="approved"
          title="Approved"
          width={width}
          editor="boolean"
          editable={editRoleFlag}
          cell={(props) => (
            <MitigationApprovedCell {...props} onEditCell={this.enterEdit} riskDetails={this.props.dataItem} />
          )}
        />
      );
    } 
    else if (cellFieldName == "name"&& !isHidden) {
      return (
        <GridColumn
          field="name"
          title="Action Title *"
          width={width}
          editable={editRoleFlag}
          locked={true}
          cell={(props) => (
            <ActionTitle {...props} onEditCell={this.enterEdit} riskDetails={this.props.dataItem}/>
          )}
        />
      );
    }
     else if (cellFieldName == "number"&& !isHidden) {
      return (
        <GridColumn
          field="number"
          title="Action Number"
          width={width}
          editable={false}
          locked={true}
        />
      );
    } else if (cellFieldName == "control"&& !isHidden) {
      return (
        <GridColumn
          field="control"
          title="Description"
          width={width}
          editable={editRoleFlag}
          cell={(props) => (
            <MitigationNameCell {...props} onEditCell={this.enterEdit} riskDetails={this.props.dataItem}/>
          )}
        />
      );
    } else if (cellFieldName == "externalReference"&& !isHidden) {
      return (
        <GridColumn
          field="externalReference"
          title="External Reference"
          width={width}
          editable={editRoleFlag}
          cell={(props) => (
            <MitigationNameCell {...props} onEditCell={this.enterEdit} riskDetails={this.props.dataItem}/>
          )}
        />
      );
    } else if (cellFieldName == "actionType"&& !isHidden) {
      return (
        <GridColumn
          field="actionType"
          title="Action Type"
          width={width}
          editable={editRoleFlag}
          cell={(props) => (
            <ActionType
              {...props}
              dropDownData={
                this.props.actionTypeListForRisk
                  ? this.props.actionTypeListForRisk
                  : []
              }
              actionTypeListForRisk={
                this.props.actionTypeListForRisk
                  ? this.props.actionTypeListForRisk
                  : []
              }
              onEditCell={this.enterEdit}
              riskDetails={this.props.dataItem}
            />
          )}
        />
      );
    } else if (cellFieldName == "cost"&& !isHidden) {
      return (
        <GridColumn
          field="cost"
          title={"Cost of Action / " + secureLocalStorage.getItem("currency")}
          width={width}
          editable={editRoleFlag}
          cell={(props) => (
            <CostComponent {...props} onEditCell={this.enterEdit} riskDetails={this.props.dataItem}/>
          )}
        />
      );
    } else if (cellFieldName == "reductionFrequency"&& !isHidden) {
      return (
        <GridColumn
          title={this.getReductionTitle("")} //"Reduction of Probability"
          width={width}
          editable={editRoleFlag}
          // locked={true}
          children={[
            {
              headerCell: this.CustomHeaderCellForProbablity,
              field: "reductionFrequency",
              width: width,
              cell: (props) => (
                <ReductionProbability {...props} onEditCell={this.enterEdit} riskDetails={this.props.dataItem}/>
              ),
            },
          ]}
        />
      );
    } else if (cellFieldName == "ImpactFields"&& !isHidden) {
      return this.state.impactMitigationColumns;
    } else if (cellFieldName == "spi"&& !isHidden) {
      return (
        <GridColumn
          field="spi"
          title="% On Track"
          editable={editRoleFlag}
          width={width}
          cell={(props) => <SPICell {...props} onEditCell={this.enterEdit} riskDetails={this.props.dataItem}/>}
        />
      );
    } else if (cellFieldName == "percentageCompletion"&& !isHidden) {
      return (
        <GridColumn
          field="percentageCompletion"
          title="% Completion"
          width={width}
          editable={editRoleFlag}
          cell={(props) => (
            <PercentageCompletion {...props} onEditCell={this.enterEdit} riskDetails={this.props.dataItem}/>
          )}
        />
      );
    } else if (cellFieldName == "originalCompletionDate"&& !isHidden) {
      return (
        <GridColumn
          field="originalCompletionDate"
          title="Original Completion Date"
          width={width}
          editor="date"
          format="{0:dd-MMM-yyyy}"
          editable={editRoleFlag}
          cell={(props) => (
            <OriginalCompDate {...props} onEditCell={this.enterEdit} riskDetails={this.props.dataItem}/>
          )}
        />
      );
    } else if (cellFieldName == "projectedCompletionDate"&& !isHidden) {
      return (
        <GridColumn
          field="projectedCompletionDate"
          title="Projected Completion Date"
          width={width}
          editor="date"
          format="{0:dd-MMM-yyyy}"
          editable={editRoleFlag}
          cell={(props) => (
            <ProjCompDate {...props} onEditCell={this.enterEdit} riskDetails={this.props.dataItem}/>
          )}
        />
      );
    } else if (cellFieldName == "actualCompletionDate"&& !isHidden) {
      return (
        <GridColumn
          field="actualCompletionDate"
          title="Actual Completion Date"
          width={width}
          editor="date"
          //editable={false}
          format="{0:dd-MMM-yyyy}"
          editable={editRoleFlag}
          cell={(props) => (
            <ActualCompDate {...props} onEditCell={this.enterEdit} riskDetails={this.props.dataItem} />
          )}
        />
      );
    } else if (cellFieldName == "proximityDate"&& !isHidden) {
      return (
        <GridColumn
          field="proximityDate"
          title="Proximity Alert Date"
          width={width}
          editor="date"
          format="{0:dd-MMM-yyyy}"
          editable={editRoleFlag}
          cell={(props) => (
            <ProximityDate {...props} onEditCell={this.enterEdit} riskDetails={this.props.dataItem}/>
          )}
        />
      );
    } else if (cellFieldName == "delayConsequence"&& !isHidden) {
      return (
        <GridColumn
          field="delayConsequence"
          title="Delay Consequence"
          width={width}
          cell={(props) => (
            <MitigationNameCell {...props} onEditCell={this.enterEdit} riskDetails={this.props.dataItem}/>
          )}
          editable={editRoleFlag}
        />
      );
    } else if (cellFieldName == "alertDescription"&& !isHidden) {
      return (
        <GridColumn
          field="alertDescription"
          title="Alert Description"
          width={width}
          cell={(props) => (
            <MitigationNameCell {...props} onEditCell={this.enterEdit} riskDetails={this.props.dataItem}/>
          )}
          editable={editRoleFlag}
        />
      );
    } else if (cellFieldName == "actionAlertStakeHolders"&& !isHidden) {
      return (
        <GridColumn
          field="actionAlertStakeHolders"
          title="Alert StakeHolders"
          width={width}
          editable={editRoleFlag}
          cell={(props) => (
            <ActionAlertStackHolderComponent
              {...props}
              onEditCell={this.enterEdit}
              stackeHolderList={
                this.props.stackeHolderList ? this.props.stackeHolderList : []
              }
              exitEdit={this.exitEdit}
              //  editOrAdd={this.state.addActionbtnHideFlag}
              riskDetails={this.props.dataItem}
            />
          )}
        />
      );
    } else if (cellFieldName == "owner"&& !isHidden) {
      return (
        <GridColumn
          field="owner"
          width={width}
          title="Owner"
          editable={editRoleFlag}
          cell={(props) => (
            <OwnerComponent
              {...props}
              onEditCell={this.enterEdit}
              dropDownData={
                this.props.ownerListForMitigation
                  ? this.props.ownerListForMitigation
                  : []                  
              }
              riskDetails={this.props.dataItem}
            />
          )}
        />
      );
    } else if (cellFieldName == "status"&& !isHidden) {
      return (
        <GridColumn
          field="status"
          width={width}
          title="Progress Status"
          editable={editRoleFlag}
          cell={(props) => (
            <ActionProgressPopup
              {...props}
              onEditCell={this.enterEdit}
              exitEdit={this.exitEdit}
              riskDetails={this.props.dataItem}
            />
          )}
        />
      );
    } else if (cellFieldName == "isOpen"&& !isHidden) {
      return (
        <GridColumn
          field="isOpen"
          title="Status"
          width={width}
          editor="boolean"
          cell={(props) => (
            <MitigationStatus {...props} onEditCell={this.enterEdit} riskDetails={this.props.dataItem} />
          )}
        />
      );
    } else if (cellFieldName == "updatedBy"&& !isHidden) {
      return (
        <GridColumn
          field="updatedBy"
          title="updated By"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
        />
      );
    } else if (cellFieldName == "updatedDate"&& !isHidden) {
      return (
        <GridColumn
          field="updatedDate"
          title="updated Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
        />
      );
    }else if (cellFieldName == "closedDate"&& !isHidden) {
      return (
        <GridColumn
          field="closedDate"
          title="Closed Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}         
        />
      );
    }else if (cellFieldName == "createdByName"&& !isHidden) {
      return (
        <GridColumn
        field="createdByName"
        width="120px"
        title="Created By"
        editable={false}
        />
      );
    }else if (cellFieldName == "createdDate"&& !isHidden) {
      return (
        <GridColumn
        field="createdDate"
        width="120px"
        title="Created Date"
        filter={"date"}
        format="{0:dd-MMM-yyyy}"
        editable={false}
        />
      );
    } else if (cellFieldName == "daysOverdue"&& !isHidden) {
      return (
        <GridColumn
          field="daysOverdue"
          title="Original Days Overdue"
          width="120px"
          editable={false}
        />
      );
    }
    else if (cellFieldName == "projectedOverdueActionCount"&& !isHidden)  {
      return (
        <GridColumn
          field="projectedOverdueActionCount"
          title="Projected Days Overdue"
          width="120px"
          editable={false}
        />
      );
    } else if (cellFieldName == "departments" && !isHidden) {
      return (
        <GridColumn
          field={cellFieldName}
          title="departments"
          width={width}
          editable={editRoleFlag}
          cell={(props) => (
            <MitigationNameCell {...props} onEditCell={this.enterEdit} riskDetails={this.props.dataItem}/>
          )}
        />
      );
    } else if (cellFieldName == "externalStatus" && !isHidden) {
      return (
        <GridColumn
          field={cellFieldName}
          title="External Status"
          width={width}
          editable={editRoleFlag}
          cell={(props) => (
            <MitigationNameCell {...props} onEditCell={this.enterEdit} riskDetails={this.props.dataItem}/>
          )}
        />
      );
    } else if (cellFieldName == "weeklyReport" && !isHidden) {
      return (
        <GridColumn
          field={cellFieldName}
          title="Weekly Report"
          width={width}
          editable={editRoleFlag}
          cell={(props) => (
            <MitigationNameCell {...props} onEditCell={this.enterEdit} riskDetails={this.props.dataItem}/>
          )}
        />
      );
    } else {
      let imp =
        this.state.impactMitigationColumns &&
        this.state.impactMitigationColumns.find(
          (impact) => cellFieldName === impact.props.children[0].field
        );
      if (imp) {
        return imp;
      }
    }
  };

  isHiddenRiskColumn=(field)=>{
    return this.props.selectedActionsColumnFields?.some((item)=>item.fieldName===field);
  }

  notavailable = () => {
    return (
      <td className="k-grid-content-sticky editBtns">
        <ul className="actionIcon">
          <span>NA</span>
        </ul>
      </td>
    );
  };

  CustomHeaderCell = (props, impactMaster) => {
    var impactTemp = impactMaster.find((item) => item.name == props.field);
    if (impactTemp) {
      var val = this.getOriginalValueFromRisk(props.field);
      return (
        <span>
          <span title="Pre Value"> {val.split("/")[0]}</span>
          <span className="skyBlueCell" title="Current Value">
            {""} ({val.split("/")[2]})
          </span>
          <span className="yellowCell" title="Post Value">
            {""} ({val.split("/")[1]})
          </span>
        </span>
      );
    }
  };
  CustomHeaderCellForProbablity = (props) => {
    let riskval = this.props.dataItem.frequency;
    let actionVal = this.props.dataItem.reductionProbability;
    let currentProbability = this.props.dataItem.currentProbability;
    return (
      <span>
        <span title="Original Value"> {riskval}</span>

        <span className="skyBlueCell reductionProbVal" title="Current Value">
          {""} ({currentProbability ? currentProbability : 0})
        </span>
        <span className="yellowCell reductionProbVal" title="Approved Value">
          {""} ({actionVal ? actionVal : 0})
        </span>
      </span>
    );
  };

  closeRiskFormView = (flag) => {
    this.setState({
      ...this.state,
      showFormView: false,
      formData: {},
      formEditFlag: false,
    });
    if (flag == "REFRESH") {
      this.props.refreshRisk();
    }
  };
  addRiskDataFromForm = () => {
    this.props.refreshRisk();
  };
  editFormView = (dataItem) => {
    try {
      this.setState({
        ...this.state,
        showFormView: true,
        formData: dataItem,
        formEditFlag: true,
      });
    } catch (err) {
      console.error(err);
    }
  };
  render() {

    const data = this.props.dataItem.mitigationResps
      ? this.props.dataItem.mitigationResps
      : {};
      const loginUserId=parseInt(secureLocalStorage.getItem("loginUserId"));
    const editRoleFlag = data.isOpen == false || data.isOpen == "No" ? false : true;
    return (
      <div className="riskReportMitigation" id="home-riskMitigation">
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        {
          this.state.showFormView===true&&(
        <ActionRegisterFormView
          formEditFlag={this.state.formEditFlag}
          formData={this.state.formData}
          showFormView={this.state.showFormView}
          orgUnit={this.props.orgUnit}
          heatMapCount={this.props.heatmapCount}
          closeRiskFormView={this.closeRiskFormView}
          addRiskDataFromForm={this.addRiskDataFromForm}
          dropDownData={
            this.props.stackeHolderList ? this.props.stackeHolderList : []
          }
          ownerListForRisk={
            this.props.ownerListForMitigation
              ? this.props.ownerListForMitigation
              : []
          }
          actionTypeList={
            this.props.actionTypeListForRisk
              ? this.props.actionTypeListForRisk
              : []
          }
          riskDetails={this.props.dataItem}
          role={this.props.dataItem.role}
          selectedActionsColumnFields={this.props.selectedActionsColumnFields}
          {...this.props}
        />
          )
        }
        
        <Grid
          ref={this.gridRef}
          data={this.state.data}
          cellRender={this.cellRender}
          rowRender={this.rowRender}
          reorderable={this.state.data.length == 0 ? false : true}
          resizable={this.state.data.length == 0 ? false : true}
          editField="inEdit"
          onItemChange={this.itemChange}
          onColumnReorder={this.props.pageName === "Home" ? this.onColumnReorderHomePage:this.onColumnReorder}
          onColumnResize={this.props.pageName === "Home" ? this.onColumnResizeHomePage:this.onColumnResize}
        >
          {this.props.dataItem.role == "View Only" ||
          this.props.dataItem.role == "Standard User" ? (
            this.props.dataItem.userId===loginUserId&&(
        <GridToolbar>
            <div>
              {this.state.addActionbtnHideFlag &&
                this.props.dataItem.riskRegisterId && (
                  <>
                    <button
                      title="Add new"
                      className="k-button k-primary addRisks"
                      onClick={this.addRecord}
                    >
                      Add Actions
                    </button>
                  </>
                )}
            </div>
          </GridToolbar>
            )
            
          ) : (
            <GridToolbar>
              <div>
                {this.state.addActionbtnHideFlag &&
                  this.props.dataItem.riskRegisterId && (
                    <>
                      <button
                        title="Add new"
                        className="k-button k-primary addRisks"
                         id="action-id"

                        onClick={this.addRecord}
                        
                      >
                        Add Actions
                      </button>
                    </>
                  )}
              </div>
            </GridToolbar>
          )}

          {this.props.dataItem.role == "View Only" ||
          this.props.dataItem.role == "Standard User" ? (
            <GridColumn
              cell={this.actionButtonsForViewOnly}
              width="85px"
              filterable={false}
            />
          ) : (
            <GridColumn
              cell={this.actionButtons}
              width="85px"
              filterable={false}
            />
            
          )}
            
          {this.props.persistenceActionGrid &&
            this.props.persistenceActionGrid.map((columns) =>
              this.getGridColum(columns, editRoleFlag)
            )}
            
        
        </Grid>

        <Popup
          show={this.state.openDeleteModelFlagView}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont">
            <h3>Are you sure you want to delete this action?</h3>
            <div className="btnCont">
              <button
                onClick={() => this.deleteMitigation()}
                className="deleteBtn"
                type="button"
              >
                Delete
              </button>
              <button
                onClick={this.closeDeletePopup}
                className="cancelBtn"
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
        <Popup
          show={this.state.actionCompletionDatePopup}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont actualCompPopup">
            <h3>Action Update</h3>
            <div className="labelBlock">
              <label className="fieldLabel1">
              <span className="fieldTitle">Action Title :</span>
                 {this.state.currentChangedValue?.name}
              </label>
             
              <label className="fieldLabel2">
                <span className="fieldTitle">Action Number : </span>
                {this.state.currentChangedValue?.number}
              </label>
              </div>
              <label className="fieldLabel3">
                <span className="fieldTitle">Actual Completion Date</span></label>
            
              <DatePicker
                format="dd-MMM-yyyy"
                onChange={(e) =>
                  this.handleActulaCompletionDate(e.target.value)
                }
              />
          
            <div className="btnCont">
              <button
                onClick={() =>
                  this.closeEditandSaveMitigation(
                    this.state.currentChangedValue
                  )
                }
                type="button"
                className="deleteBtn"
              >
                Submit
              </button>
              <button
                onClick={this.closeActionCompletionDatePopup}
                className="cancelBtn"
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
